export default "__VITE_ASSET__f706a6f0__"